import forEach from '../_helpers/foreach.js';
import MatreshkaArray from './index.js';
// converts array-like to Matreshka.Array instance
export default function toMatreshkaArray(arrayLike) {
  var result = new MatreshkaArray(arrayLike.length);
  forEach(arrayLike, function (item, index) {
    result[index] = item;
  });
  return result;
}